export enum WidthStyle {
    content = 0,
    fullpage = 1
}
